<template>
  <div>
    <div class="myTable">
      <div class="indexTitle">开放平台管理中心总表单</div>
      <div class="content">
        <div class="statistical">
          <statistical
                  :title="'总注册会员数'"
                  :number="userStatisticalDto.allCount" @goto="toUser" :is-active-style="true" style="cursor:pointer;">
          </statistical>
          <statistical
                  :title="'总农基商用户数'"
                  :number="merchantsStatisticalDto.allCount" @goto="toMerchants" :is-active-style="true"
                  style="cursor:pointer;">
          </statistical>
          <statistical
                  :title="'总农基产品数'"
                  :number="skuInfoStatisticalDto.allCount" @goto="toSkuInfo" :is-active-style="true"
                  style="cursor:pointer;">
          </statistical>
          <statistical
                  :title="'总订单数'"
                  :number="orderStatisticalDto.allCount" @goto="toOrder" :is-active-style="true"
                  style="cursor:pointer;">
          </statistical>
        </div>
      </div>
    </div>
    <div id="user" class="myTable">
      <div class="indexTitle">开放平台管理中心总表单</div>
      <div class="content">
        <div class="statistical">
          <statistical
                  :title="'总注册会员数'"
                  :number="userStatisticalDto.allCount">
          </statistical>
          <statistical
                  :title="'昨日新增'"
                  :number="userStatisticalDto.lastDayCount">
          </statistical>
          <statistical
                  :title="'本周新增'"
                  :number="userStatisticalDto.weekCount">
          </statistical>
          <statistical
                  :title="'上周新增'"
                  :number="userStatisticalDto.lastWeekCount">
          </statistical>
          <statistical
                  :title="'本月新增'"
                  :number="userStatisticalDto.monthCount">
          </statistical>
          <statistical
                  :title="'上月新增'"
                  :number="userStatisticalDto.lastMonthCount">
          </statistical>
        </div>
        <div class="indexTable">
          <user-table :tableData="userStatisticalDto.latestData"></user-table>
        </div>
      </div>
    </div>
    <div id="merchants" class="myTable">
      <div class="indexTitle">开放平台管理中心总表单</div>
      <div class="content">
        <div class="statistical">
          <statistical
                  :title="'总农基商用户数'"
                  :number="merchantsStatisticalDto.allCount">
          </statistical>
          <statistical
                  :title="'昨日新增'"
                  :number="merchantsStatisticalDto.lastDayCount">
          </statistical>
          <statistical
                  :title="'本周新增'"
                  :number="merchantsStatisticalDto.weekCount">
          </statistical>
          <statistical
                  :title="'上周新增'"
                  :number="merchantsStatisticalDto.lastWeekCount">
          </statistical>
          <statistical
                  :title="'本月新增'"
                  :number="merchantsStatisticalDto.monthCount">
          </statistical>
          <statistical
                  :title="'上月新增'"
                  :number="merchantsStatisticalDto.lastMonthCount">
          </statistical>
        </div>
        <div class="indexTable">
          <merchants-table :tableData="merchantsStatisticalDto.latestData"></merchants-table>
        </div>
      </div>
    </div>
    <div id="skuInfo" class="myTable">
      <div class="indexTitle">开放平台管理中心总表单</div>
      <div class="content">
        <div class="statistical">
          <statistical
                  :title="'总农基产品数'"
                  :number="skuInfoStatisticalDto.allCount">
          </statistical>
          <statistical
                  :title="'昨日新增'"
                  :number="skuInfoStatisticalDto.lastDayCount">
          </statistical>
          <statistical
                  :title="'本周新增'"
                  :number="skuInfoStatisticalDto.weekCount">
          </statistical>
          <statistical
                  :title="'上周新增'"
                  :number="skuInfoStatisticalDto.lastWeekCount">
          </statistical>
          <statistical
                  :title="'本月新增'"
                  :number="skuInfoStatisticalDto.monthCount">
          </statistical>
          <statistical
                  :title="'上月新增'"
                  :number="skuInfoStatisticalDto.lastMonthCount">
          </statistical>
        </div>
        <div class="indexTable">
          <sku-info-table :tableData="skuInfoStatisticalDto.latestData"></sku-info-table>
        </div>
      </div>
    </div>
    <div id="order" class="myTable">
      <div class="indexTitle">开放平台管理中心总表单</div>
      <div class="content">
        <div class="statistical">
          <statistical
                  :title="'总订单数'"
                  :number="orderStatisticalDto.allCount">
          </statistical>
          <statistical
                  :title="'昨日新增'"
                  :number="orderStatisticalDto.lastDayCount">
          </statistical>
          <statistical
                  :title="'本周新增'"
                  :number="orderStatisticalDto.weekCount">
          </statistical>
          <statistical
                  :title="'上周新增'"
                  :number="orderStatisticalDto.lastWeekCount">
          </statistical>
          <statistical
                  :title="'本月新增'"
                  :number="orderStatisticalDto.monthCount">
          </statistical>
          <statistical
                  :title="'上月新增'"
                  :number="orderStatisticalDto.lastMonthCount">
          </statistical>
        </div>
        <div class="indexTable">
          <order-table :tableData="orderStatisticalDto.latestData"></order-table>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Statistical from "../../components/content/statistical/Statistical";
  import UserTable from "../user/UserTable";
  import MerchantsTable from "../merchants/MerchantsTable";
  import SkuInfoTable from "../earth_plan/SkuInfoTable";
  import OrderTable from "../order/OrderTable";
  import {getMerchantsCount, getOrderCount, getSkuInfoCount, getUserCount, newVue} from "../../network/index"

  export default {
    name: "Index",
    components: {OrderTable, SkuInfoTable, MerchantsTable, UserTable, Statistical},
    data() {
      return {
        userStatisticalDto: {
          latestData: []
        },
        merchantsStatisticalDto: {
          latestData: []
        },
        skuInfoStatisticalDto: {
          latestData: []
        },
        orderStatisticalDto: {
          latestData: []
        }
      }
    },
    created() {
      newVue.obj = this
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
      this.common.HeaderLocationTwo.href = "/index";
      this.common.HeaderLocationTwo.name = "~"
      this.common.HeaderLocationThree.name = "~"
      getUserCount().then(res => {
        this.userStatisticalDto = res.data
      })
      getMerchantsCount().then(res => {
        this.merchantsStatisticalDto = res.data
      })
      getSkuInfoCount().then(res => {
        this.skuInfoStatisticalDto = res.data
      })
      getOrderCount().then(res => {
        this.orderStatisticalDto = res.data
      })
    },
    methods: {
      toUser() {
        window.location.hash = "#user";
      },
      toMerchants() {
        window.location.hash = "#merchants";
      },
      toSkuInfo() {
        window.location.hash = "#skuInfo";
      },
      toOrder() {
        window.location.hash = "#order";
      },
    }

  }
</script>

<style scoped>
  .indexTitle {
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #d1d4d7;
    padding-left: 1.25rem;
    background-color: #f8f9fa;
    color: #2a2c36;
  }

  .myTable {
    margin-right: 0px;;
    margin-bottom: 15px;
    margin-left: 200px;
    background-color: #fff;
    font-size: 0.875rem;
  }

  .content {
    background-color: #fff;
    padding-bottom: 15px;
  }

  .statistical {
    display: flex;
    justify-content: space-around;
  }

  .indexTable {
    margin: 15px;
  }
</style>
